module.exports = __webpack_public_path__ + "static/media/silver_member_banner.2b6ab24a.webp";